export const facebookMessageConfirmOrderInitialState = {
  pages: {
    list: [],
    loading: true,
  },
  modal: {confirmStatus: {data: null, open: false}},
  isDataLoaded: false,
  detail: {
    samples:[
      {
        "type": "paragraph",
        "children": [
          {
            "text": "ឧបត្ថម្ភការបញ្ជាទិញរបស់អតិថិជន "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{ឈ្មោះ និងត្រកូល}"
              }
            ]
          },
          {
            "text": " បានដាក់បញ្ជាទិញដោយជោគជ័យ។ លេខកូដបញ្ជាទិញគឺ៖ "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{លេខកូដបញ្ជាទិញ}"
              }
            ]
          },
          {
            "text": " លេខកូដដឹកជញ្ជូន "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{លេខកូដដឹកជញ្ជូន}"
              },

            ]
          },
          {
            "text": " និងតំណភ្ជាប់សម្រាប់ពិនិត្យមើលដំណើរការដឹកជញ្ជូន "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{តំណភ្ជាប់សម្រាប់ពិនិត្យមើលដំណើរការដឹកជញ្ជូន}"
              },

            ]
          },
          {
            "text": " "
          },
        ]
      },
    ],
    content_message: [ {
      "type": "paragraph",
      "children": [
        {
          "text": "ឧបត្ថម្ភការបញ្ជាទិញរបស់អតិថិជន "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{ឈ្មោះ និងត្រកូល}"
            }
          ]
        },
        {
          "text": " បានដាក់បញ្ជាទិញដោយជោគជ័យ។ លេខកូដបញ្ជាទិញគឺ៖ "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{លេខកូដបញ្ជាទិញ}"
            }
          ]
        },
        {
          "text": " លេខកូដដឹកជញ្ជូន "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{លេខកូដដឹកជញ្ជូន}"
            },

          ]
        },
        {
          "text": " និងតំណភ្ជាប់សម្រាប់ពិនិត្យមើលដំណើរការដឹកជញ្ជូន "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{តំណភ្ជាប់សម្រាប់ពិនិត្យមើលដំណើរការដឹកជញ្ជូន}"
            },

          ]
        },
        {
          "text": " "
        },
      ]
    },],
    reset: false,
    status: 1,
    list:[
      {id: 1, name:'ឈ្មោះ និងត្រកូល'},
      {id: 2, name:'លេខទូរសព្ទ'},
      {id: 3, name:'អាសយដ្ឋាន'},
      {id: 4, name:'ឈ្មោះទំព័រ'},
      {id: 5, name:'លេខកូដបញ្ជាទិញ'},
      {id: 6, name:'លេខកូដដឹកជញ្ជូន'},
      {id: 7, name:'តំណភ្ជាប់សម្រាប់ពិនិត្យមើលដំណើរការដឹកជញ្ជូន'},
      {id: 8, name:'ប្រាក់ប្រមូលទិញយកតាមក្រោយ (COD)'},
    ],
    validate:''
  },
  livestreamDetail: {
    samples:[
      {
        "type": "paragraph",
        "children": [
          {
            "text": "ការបញ្ជាទិញរបស់អតិថិជនត្រូវបានដាក់ដោយជោគជ័យ។ លេខកូដបញ្ជាទិញគឺ៖ "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{លេខកូដបញ្ជាទិញ}"
              }
            ]
          },
          {
            "text": " ជាមួយនឹងផលិតផល៖ "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{ខ្លឹមសារមតិយោបល់}"
              }
            ]
          },
          {
            "text": "។ សូមអរគុណដែលបានបញ្ជាទិញនៅទំព័រ "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{ឈ្មោះទំព័រ}"
              }
            ]
          },
          {
            "text": " "
          },
        ]
      },
    ],
    content_message: [ {
      "type": "paragraph",
      "children": [
        {
          "text": "ការបញ្ជាទិញរបស់អតិថិជនត្រូវបានដាក់ដោយជោគជ័យ។ លេខកូដបញ្ជាទិញគឺ៖ "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{លេខកូដបញ្ជាទិញ}"
            }
          ]
        },
        {
          "text": " ជាមួយនឹងផលិតផល៖ "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{ខ្លឹមសារមតិយោបល់}"
            }
          ]
        },
        {
          "text": "។ សូមអរគុណដែលបានបញ្ជាទិញនៅទំព័រ "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{ឈ្មោះទំព័រ}"
            }
          ]
        },
        {
          "text": " "
        },
      ]
    },],
    reset: false,
    status: 0,  // Mặc định OFF
    list:[
      {id: 1, name:'ឈ្មោះ និងត្រកូល'},
      {id: 2, name:'លេខទូរសព្ទ'},
      {id: 3, name:'អាសយដ្ឋាន'},
      {id: 4, name:'ឈ្មោះទំព័រ'},
      {id: 5, name:'លេខកូដបញ្ជាទិញ'},
      {id: 6, name:'ខ្លឹមសារមតិយោបល់'},
    ],
    validate:''
  }
}
